import { CobaltCountryISOEnum } from '@cae/cobalt-react/components/phone-number-input';

import type { Profile } from '../../profile.types';
import type { ContactFormState } from './useEditContactPanel.types';

import {
  convertToClientProfileFormat,
  parsePhoneInfo,
} from '../../utils/format-phone-number/formatPhoneNumber.utils';

function buildInitialContactFormState(profile?: Profile): ContactFormState {
  return {
    email: profile?.email ?? '',
    mobileNumber: profile?.mobileNumber ?? '',
  };
}

function resolvePhoneCountry(country?: string): string {
  return country || CobaltCountryISOEnum.Canada;
}

function normalizeContactPhoneValue(phone?: string | null): string {
  const trimmed = (phone ?? '').trim();
  if (!trimmed) return '';

  const parsed = parsePhoneInfo(trimmed);
  if (!parsed || !parsed.getNationalNumber()) return '';

  return convertToClientProfileFormat(trimmed);
}

export {
  buildInitialContactFormState,
  normalizeContactPhoneValue,
  resolvePhoneCountry,
};
